import * as React from 'react';
import { useToasterBehavior } from './useToasterBehavior';

export const Toaster = () => {
  const { visible, state, onChange } = useToasterBehavior();
  return (
    <>
      {visible && (
        <div style={{ zIndex: '1010' }} className="position-fixed p-3 top-0 start-50 translate-middle-x">
          <div
            className={[state?.className, 'toast fade show'].join(' ')}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="toast-header">
              <img
                style={{ width: '2rem' }}
                className="img-thumbnail rounded me-2"
                src="/img/robot.gif"
                alt="Mikrobi"
              />
              <strong data-testid="toasterTitle" className="me-auto">
                {state?.title}
              </strong>
              <button
                onClick={onChange}
                type="button"
                className="btn-close"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
            <div data-testid="toasterMessage" className="toast-body">
              {state?.message}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
